var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.75V12.125C19.5 11.2299 19.1444 10.3715 18.5115 9.73851C17.8786 9.10558 17.0201 8.75 16.125 8.75H14.625C14.3266 8.75 14.0405 8.63147 13.8295 8.4205C13.6185 8.20952 13.5 7.92337 13.5 7.625V6.125C13.5 5.22989 13.1444 4.37145 12.5115 3.73851C11.8785 3.10558 11.0201 2.75 10.125 2.75H8.25M10.5 2.75H5.625C5.004 2.75 4.5 3.254 4.5 3.875V21.125C4.5 21.746 5.004 22.25 5.625 22.25H18.375C18.996 22.25 19.5 21.746 19.5 21.125V11.75C19.5 9.36305 18.5518 7.07387 16.864 5.38604C15.1761 3.69821 12.8869 2.75 10.5 2.75Z",
    stroke: "#C9C9C9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.deebc093b2b267a2c92c3622dec28545.svg";
export { ForwardRef as ReactComponent };